var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { alpha, useTheme } from "@mui/material";
import { PickersDay } from "@mui/x-date-pickers";
import { useGetContrastColor } from "../../hooks/useGetContrastColor";
import { PickersDayStyledBadge } from "./PickersDayStyledBadge";
import { dayChangeHandler } from "./dateTimeUtils";
import { useSkipDaysPickerValues } from "./useSkipDaysPickersValues";
export const SkipDaysCustomPickersDay = (_a) => {
    var { allSkipDays, badgeProps, currentMonth, customDaySelect, // placeholder, may not need this
    daysForCurrentMonth, handleOpenWarningModal, handleUpdateSkipDay, onDaySelect, setDayToSkip } = _a, rest = __rest(_a, ["allSkipDays", "badgeProps", "currentMonth", "customDaySelect", "daysForCurrentMonth", "handleOpenWarningModal", "handleUpdateSkipDay", "onDaySelect", "setDayToSkip"]);
    const { day } = rest;
    const theme = useTheme();
    const { isDisabledDay, isInCurrentMonth, isSkipDay, selectedBackgroundColor, selectedTextColor, targetDay, updatedBadgeProps, } = useSkipDaysPickerValues(allSkipDays, badgeProps, currentMonth, day, daysForCurrentMonth);
    return (_jsx(PickersDayStyledBadge, Object.assign({}, Object.assign({ day }, updatedBadgeProps), { children: _jsx(PickersDay, Object.assign({}, rest, { outsideCurrentMonth: !isInCurrentMonth, selected: !!isSkipDay, disabled: isDisabledDay || !isInCurrentMonth, sx: {
                // I would have preferred a styled component here, but there are prop conflicts that I can't figure out.
                "&.MuiPickersDay-root": {
                    color: theme.palette.primary.main,
                    fontWeight: 900,
                },
                "&.MuiPickersDay-root.Mui-selected": {
                    color: selectedTextColor,
                    backgroundColor: selectedBackgroundColor,
                    border: `2px solid ${theme.palette.primary.main}`,
                },
                "&.MuiPickersDay-root.Mui-disabled": {
                    color: alpha(theme.palette.text.disabled, 0.15),
                },
            }, onDaySelect: customDaySelect
                ? customDaySelect
                : dayChangeHandler(handleOpenWarningModal, handleUpdateSkipDay, isDisabledDay, isSkipDay, setDayToSkip, targetDay) })) })));
};
export const SimpleCustomPickersDay = (props) => {
    const theme = useTheme();
    const selectedDayBackground = alpha(theme.palette.primary.light, 0.1);
    const contrastColor = useGetContrastColor(selectedDayBackground);
    return (_jsx(PickersDay, Object.assign({}, props, { sx: {
            // I would have preferred a styled component here, but there are prop conflicts that I can't figure out.
            "&.MuiPickersDay-root": {
                color: theme.palette.primary.main,
                fontWeight: 900,
            },
            "&.MuiPickersDay-root.Mui-selected": {
                color: contrastColor,
                backgroundColor: selectedDayBackground,
                border: `2px solid ${theme.palette.primary.main}`,
            },
            "&.MuiPickersDay-root.Mui-disabled": {
                color: alpha(theme.palette.text.disabled, 0.15),
            },
        } })));
};
